/* globals Virtru, window */
// MIT License
//
// Copyright (c) 2019 Virtru Corporation
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

export const AUTH_TYPE_GOOGLE = 'AUTH_TYPE_GOOGLE';
export const AUTH_TYPE_O365 = 'AUTH_TYPE_O365';
export const AUTH_TYPE_OUTLOOK = 'AUTH_TYPE_OUTLOOK';

const queryParam = 'virtruAuthWidgetEmail';
const defaultRedirectUrl = window.location.href;

export function getEmailFromQuery() {
  const params = window.location.search.split('&');
  const paramRegex = new RegExp(`${queryParam}=(.*)`);
  let email;
  params.find((param) => {
    const emailMatch = param.match(paramRegex);
    if (emailMatch) {
      email = emailMatch[1];
    }
    return emailMatch;
  });
  return email || false;
}

export function loginWith(authType, email, redirectUrl = '', options = {}) {
  let url = defaultRedirectUrl;
  if (redirectUrl) {
    url = redirectUrl;
  }
  let prepend = '?';
  if (redirectUrl.match(/\?/)) {
    prepend = '&';
  }
  url += `${prepend}${queryParam}=${email}`;
  switch (authType) {
    case AUTH_TYPE_GOOGLE:
      return Virtru.Auth.loginWithGoogle({ email, redirectUrl: url, ...options });
    case AUTH_TYPE_O365:
      return Virtru.Auth.loginWithOffice365({ email, redirectUrl: url, ...options });
    case AUTH_TYPE_OUTLOOK:
      return Virtru.Auth.loginWithOutlook({ email, redirectUrl: url, ...options });
    default:
      throw new Error('No auth type found', authType);
  }
}

export function requestCode(email, options = {}) {
  return Virtru.Auth.sendCodeToEmail({ email, ...options });
}

export function activateCode(email, code, redirectUrl, options = {}) {
  return Virtru.Auth.activateEmailCode({ email, code, redirectUrl, ...options });
}
